/** English of the interface (ADR 0069), keyed by the exact French phrase. See `index.ts`. */
export const ITEMS: Readonly<Record<string, string>> = {
  // ui/alchemy-panel.ts
  'Demande invalide.': 'Invalid request.',
  'Cet alchimiste ne prépare pas cette potion.': 'This Alchemist does not brew that potion.',
  'Il te manque des ingrédients.': 'You are missing ingredients.',
  'Ta bourse n’y suffit pas.': 'You cannot afford it.',
  'Ton sac est plein.': 'Your Bag is full.',
  'Approche-toi de l’alchimiste.': 'Get closer to the Alchemist.',
  Alchimiste: 'Alchemist',
  'Fermer (Échap)': 'Close (Esc)',
  'Rapporte-moi ce que laissent les bêtes du pays : j’en tire des potions de vie.':
    'Bring me what the local beasts leave behind: I turn it into health potions.',
  'Rend {heal} points de vie': 'Restores {heal} Health',
  'Niveau {level}': 'Level {level}',
  Préparer: 'Brew',
  // ui/boss-bar.ts
  'Butin du jour à prendre': 'Loot of the day to take',
  'Butin du jour déjà pris': 'Loot of the day already taken',
  'De retour dans {seconds} s': 'Back in {seconds} s',
  // ui/boss-defeat-tip.ts
  'Fais améliorer ton équipement chez le forgeron : chaque niveau (+3, +4…) ajoute des dégâts, de la vie ou de la défense.':
    'Get your Equipment upgraded at the Blacksmith: each level (+3, +4…) adds damage, Health or Defense.',
  'Prépare des potions de vie chez l’alchimiste avec les matériaux des créatures, ou achète-en au marchand, et bois-les pendant le combat.':
    'Brew health potions at the Alchemist with creature Materials, or buy some from the Merchant, and drink them during the fight.',
  'Complète le set de la région : ses pièces rares tombent sur les créatures, les élites et dans les coffres des camps.':
    'Complete the region’s set: its rare pieces drop from creatures, Elites and Camp Chests.',
  'Quand le boss s’arrête, des cases s’allument au sol : sors-en avant qu’il frappe.':
    'When the Boss stops, tiles light up on the ground: step out before it strikes.',
  'Ce boss t’a vaincu': 'This Boss defeated you',
  'Pas encore !': 'Not yet!',
  'Un boss se bat bien préparé. Avant d’y retourner :':
    'A Boss is fought well prepared. Before going back:',
  Compris: 'Got it',
  // ui/combat-lines.ts
  'plafond atteint': 'cap reached',
  Critique: 'Critical',
  'Chance de coup critique, et ce qu’il multiplie': 'Critical hit chance, and what it multiplies',
  'DPS boss et élites': 'DPS vs Bosses & Elites',
  'DPS moyen contre un boss ou une élite': 'Average DPS against a Boss or an Elite',
  Recharge: 'Cooldown',
  'Recharge des sorts raccourcie': 'Shorter Spell Cooldowns',
  'Énergie par seconde': 'Energy per second',
  'Énergie regagnée chaque seconde': 'Energy regained each second',
  'Vol de vie': 'Lifesteal',
  'Part des dégâts infligés rendue en vie': 'Share of damage dealt returned as Health',
  // ui/item-source-text.ts
  '{mob} · {region} ({chance})': '{mob} · {region} ({chance})',
  'Gardiens des lieux d’intérêt · {region}': 'Guardians of points of interest · {region}',
  'Élites · {region}': 'Elites · {region}',
  '{mob}, boss · {region}': '{mob}, Boss · {region}',
  '{mob}, boss · {region} ({chance})': '{mob}, Boss · {region} ({chance})',
  'Coffres des camps · {region}': 'Camp Chests · {region}',
  'Coffres cachés et des camps · {region}': 'Hidden and Camp Chests · {region}',
  'Butin des monstres · {region}': 'Monster Loot · {region}',
  'Marchand des villages': 'Village Merchant',
  'Alchimiste · {village}': 'Alchemist · {village}',
  '… et {count} autres créatures': '… and {count} other creatures',
  '… et {count} autre créature': '… and {count} other creature',
  // ui/item-tooltip.ts
  Commun: 'Common',
  Rare: 'Rare',
  Épique: 'Epic',
  Légendaire: 'Legendary',
  Casque: 'Helmet',
  Plastron: 'Chestplate',
  Gants: 'Gloves',
  Bottes: 'Boots',
  Arme: 'Weapon',
  'Main gauche': 'Off-hand',
  Familier: 'Pet',
  Monture: 'Mount',
  Ailes: 'Wings',
  Traînée: 'Trail',
  Vie: 'Health',
  Défense: 'Defense',
  DPS: 'DPS',
  'Alchimiste : {potion} (×{quantity})': 'Alchemist: {potion} (×{quantity})',
  'Forgeron : améliore les pièces de la région {region} (+{from} à +{to})':
    'Blacksmith: upgrades the {region} region’s pieces (+{from} to +{to})',
  'Fondeur : 5 identiques donnent {result}': 'Smelter: 5 identical make {result}',
  'Fondeur : 5 identiques donnent {result} ({rarity})':
    'Smelter: 5 identical make {result} ({rarity})',
  Consommable: 'Consumable',
  Matériau: 'Material',
  '{rarity} · Cosmétique · {kind}': '{rarity} · Cosmetic · {kind}',
  'Se porte par-dessus ton équipement, sans en changer les stats':
    'Worn over your Equipment, without changing its stats',
  'Niveau {level} requis': 'Requires Level {level}',
  '+{value} % de vitesse de déplacement': '+{value}% movement speed',
  ' (scellée)': ' (sealed)',
  ' (plafond atteint)': ' (cap reached)',
  'À utiliser près d’un terrier ({den}) : fait sortir {summons}, pour toi et ton groupe':
    'Use near a burrow ({den}): lures out {summons}, for you and your Party',
  'Comparé à ce que tu portes': 'Compared to what you wear',
  'Rien de porté à cet emplacement': 'Nothing worn in this slot',
  // ui/item-icon.ts
  'Mieux que ce que tu portes': 'Better than what you wear',
  'Porté : {name}{plus}': 'Worn: {name}{plus}',
  '{sign}{value} % de vitesse de déplacement': '{sign}{value}% movement speed',
  'Perd {affix}': 'Loses {affix}',
  Utilisation: 'Uses',
  'Aucun artisan ne s’en sert : à vendre au marchand':
    'No craftsman uses it: sell it to the Merchant',
  Obtention: 'Where to get it',
  'Objet lié à ton personnage': 'Bound to your Character',
  'Il ne s’échange pas, ne passe ni à l’Hôtel des ventes ni au Coffre du compte. Le marchand le rachète.':
    'It can’t be traded, put up at the Auction House or stored in the account Chest. The Merchant still buys it.',
  'Échangeable à partir du {date}': 'Tradable from {date}',
  'Vente : {price} or': 'Sells for {price} gold',
  '{rarity} · {kind}': '{rarity} · {kind}',
  '+{value} {stat}': '+{value} {stat}',
  '{affix}{notes}': '{affix}{notes}',
  ' [{range}]': ' [{range}]',
  '= {stat}': '= {stat}',
  '{sign}{value} {stat}': '{sign}{value} {stat}',
  // ui/effect-strip.ts
  Étourdi: 'Stunned',
  Ralenti: 'Slowed',
  Saignement: 'Bleeding',
  Provoqué: 'Taunted',
  'Dégâts reçus réduits de {share}.': 'Damage taken reduced by {share}.',
  'DPS augmenté de {share}.': 'DPS increased by {share}.',
  'Ne bouge ni ne frappe.': 'Can neither move nor strike.',
  'Avance deux fois moins vite.': 'Moves at half speed.',
  'Avance moins vite.': 'Moves slower.',
  'Perd de la vie chaque seconde.': 'Loses Health every second.',
  'Ne s’en prend qu’à celui qui l’a provoqué.': 'Attacks only whoever taunted it.',
  '{name} : {effect}': '{name}: {effect}',
  'Encore {seconds} s.': '{seconds} s left.',
  // ui/fusion-panel.ts
  'Cette pièce ne se fusionne pas.': 'This piece cannot be fused.',
  'Il faut {count} pièces identiques dans ton sac.':
    'You need {count} identical pieces in your Bag.',
  'Approche-toi du fondeur.': 'Get closer to the Smelter.',
  '{stat} {value}': '{stat} {value}',
  Fondeur: 'Smelter',
  '{count} pièces identiques de ton sac en font une de la rareté au-dessus. Les pièces portées ne comptent pas ; leurs améliorations sont perdues.':
    '{count} identical pieces from your Bag make one of the next rarity. Worn pieces do not count; their Upgrades are lost.',
  '{name} · {worn} portée(s), hors fusion': '{name} · {worn} worn, not counted',
  'Tu en portes {worn} : retire-la pour qu’elle compte.':
    'You wear {worn}: take it off for it to count.',
  'Tu en portes {worn} : retire-les pour qu’elles comptent.':
    'You wear {worn}: take them off for them to count.',
  'Aucune pièce à fusionner dans ton sac.': 'No pieces to fuse in your Bag.',
  '{count} × {name}': '{count} × {name}',
  '{name} ({rarity})': '{name} ({rarity})',
  Fusionner: 'Fuse',
  'Équiper : {name}': 'Equip: {name}',
  commun: 'common',
  rare: 'rare',
  épique: 'epic',
  légendaire: 'legendary',
  // ui/merchant-panel.ts
  'Tu n’as plus cet objet dans ton sac.': 'That item is no longer in your Bag.',
  'Le marchand n’en veut pas.': 'The Merchant does not want it.',
  'Garde-le, tu en as besoin pour les leçons du camp.':
    'Keep it, you need it for the camp’s lessons.',
  'Tu n’en as pas autant.': 'You do not have that many.',
  'Approche-toi du marchand.': 'Get closer to the Merchant.',
  'Il ne vend pas ça ici.': 'He does not sell that here.',
  '{amount} or': '{amount} gold',
  Marchand: 'Merchant',
  Acheter: 'Buy',
  Vendre: 'Sell',
  'Vendu : {what} pour {gold}.': 'Sold: {what} for {gold}.',
  'Acheté : {what} pour {gold}.': 'Bought: {what} for {gold}.',
  'Ta bourse': 'Your purse',
  'Butin vendu : {count} objets pour {gold}.': 'Loot sold: {count} items for {gold}.',
  // ui/merchant-buy-view.ts
  Provisions: 'Supplies',
  '{total} ({each} l’unité)': '{total} ({each} each)',
  'niveau {level}': 'Lv. {level}',
  'Dans ton sac : {count}': 'In your Bag: {count}',
  'Aucun dans ton sac': 'None in your Bag',
  'Un de moins': 'One fewer',
  'Un de plus': 'One more',
  // ui/merchant-sell-view.ts
  'Rien dans ton sac ne l’intéresse.': 'Nothing in your Bag interests him.',
  'Ton butin vaut {gold}.': 'Your loot is worth {gold}.',
  'Pas de butin à vendre.': 'No loot to sell.',
  'Vendre tout le butin': 'Sell all loot',
  Filtrer: 'Filter',
  Tout: 'All',
  Matériaux: 'Materials',
  Consommables: 'Consumables',
  '{each} l’unité · {count} dans ton sac': '{each} each · {count} in your Bag',
  'Sûr ?': 'Sure?',
  // ui/smith-panel.ts
  'Tu ne possèdes plus cette pièce.': 'You no longer own this piece.',
  'Le forgeron ne peut rien faire de cet objet.': 'The Blacksmith can do nothing with this item.',
  'Cette pièce est déjà à +10.': 'This piece is already +10.',
  'Il te manque des matériaux.': 'You are missing Materials.',
  'Il te manque de l’or.': 'You don’t have enough gold.',
  'Approche-toi du forgeron.': 'Get closer to the Blacksmith.',
  'Le forgeron souffle un instant.': 'The Blacksmith is catching his breath.',
  'Au camp, Hald ne renforce que l’épée rare fondue chez Garin.':
    'In the camp, Hald only strengthens the rare sword Garin melted.',
  Forgeron: 'Blacksmith',
  'Réussite ! {name} passe à +{level}.': 'Success! {name} is now +{level}.',
  'Échec. {name} reste à +{level}, les matériaux sont perdus.':
    'Failed. {name} stays at +{level}, the Materials are lost.',
  '{name}{plus} (porté)': '{name}{plus} (worn)',
  '{name}{plus}': '{name}{plus}',
  'Rien à améliorer : apporte une pièce d’équipement.':
    'Nothing to upgrade: bring a piece of Equipment.',
  'Cette pièce est au sommet de son art.': 'This piece is at its very best.',
  'Réussie, elle sera liée à ton personnage.':
    'If it succeeds, it will be bound to your Character.',
  Améliorer: 'Upgrade',
  // ui/runesmith-panel.ts
  Garder: 'Keep',
  'La rune reste telle quelle (une relique)': 'The rune stays as it is (one Relic)',
  Valeur: 'Value',
  'Même rune, nouvelle valeur (une relique)': 'Same rune, new value (one Relic)',
  Rune: 'Rune',
  'Une autre rune, tirée au hasard': 'Another rune, drawn at random',
  Sceller: 'Seal',
  'Gardée pour toujours, plus jamais modifiable ({count} reliques, une fois)':
    'Kept forever, never changeable again ({count} Relics, once)',
  'Le graveur ne peut rien graver sur cet objet.':
    'The Runesmith cannot engrave anything on this item.',
  'Laisse au moins une rune à regraver.': 'Leave at least one rune to re-engrave.',
  'Cette rune n’est plus sur la pièce.': 'This rune is no longer on the piece.',
  'Cette rune est scellée : on ne peut plus y toucher.':
    'This rune is sealed: it can no longer be touched.',
  'Approche-toi du graveur.': 'Get closer to the Runesmith.',
  'Le graveur souffle un instant.': 'The Runesmith is catching his breath.',
  'Le graveur ne travaille pas tant que le village est attaqué.':
    'The Runesmith does not work while the village is under attack.',
  'Graveur de runes': 'Runesmith',
  'Les runes de {name} sont regravées.': 'The runes of {name} are re-engraved.',
  '{name} (porté)': '{name} (worn)',
  'Rien à graver : apporte une pièce rare, épique ou légendaire trouvée en chassant.':
    'Nothing to engrave: bring a rare, epic or legendary piece found while hunting.',
  'Coût de la gravure': 'Engraving cost',
  'Une rune scellée ne pourra plus jamais être changée.':
    'A sealed rune can never be changed again.',
  'Graver et sceller': 'Engrave and seal',
  Graver: 'Engrave',
  'Scellée pour toujours': 'Sealed forever',
  'Runes possibles sur cette pièce': 'Possible runes on this piece',
  Avant: 'Before',
  Après: 'After',
  // ui/spell-bar.ts
  'Emplacement libre : ouvrir le grimoire': 'Empty slot: open the Spellbook',
  'Descendre de ta monture': 'Get off your Mount',
  'Monter sur ta monture': 'Get on your Mount',
  '{label} ({key})': '{label} ({key})',
  'Niv. {level} · {gained} / {needed} XP': 'Lv. {level} · {gained} / {needed} XP',
  'Niv. {level}': 'Lv. {level}',
  '{name} — {description} ({cost})': '{name} — {description} ({cost})',
  '{cost} énergie · recharge {cooldown} s': '{cost} Energy · {cooldown} s Cooldown',
  // ui/quick-potion.ts
  'Aucune potion de vie dans ton sac': 'No health potion in your bag',
  'Boire : {name} (×{count})': 'Drink: {name} (×{count})',
  'Ta vie est déjà pleine.': 'Your health is already full.',
  // ui/spellbook-list.ts
  'Mettre {name} dans la barre': 'Put {name} on the bar',
  'Dans la barre': 'On the bar',
  'Quête : {name}': 'Quest: {name}',
  // ui/spellbook-panel.ts
  'Tu ne connais pas encore ce sort.': 'You do not know this Spell yet.',
  'Ce sort est déjà dans ta barre.': 'This Spell is already on your bar.',
  'Barre de sorts invalide.': 'Invalid Spell bar.',
  'Impossible en combat.': 'Not possible in combat.',
  'Impossible à terre.': 'Not possible while down.',
  'Glisse un sort sur un emplacement, ou clique le sort puis l’emplacement. Clic droit pour vider.':
    'Drag a Spell onto a slot, or click the Spell then the slot. Right-click to empty.',
  'Touche un sort, puis l’emplacement où le mettre.': 'Tap a Spell, then the slot to put it in.',
  Grimoire: 'Spellbook',
  Retirer: 'Remove',
  'Emplacement {slot} : libre': 'Slot {slot}: empty',
  'Emplacement {slot} : {name}': 'Slot {slot}: {name}',
  'Choisis l’emplacement de ce sort.': 'Pick a slot for this Spell.',
  'Choisis l’emplacement de {name}.': 'Pick a slot for {name}.',
  'Choisis un autre emplacement pour échanger, ou retire le sort.':
    'Pick another slot to swap, or remove the Spell.',
  // ui/inventory-panel.ts
  Tête: 'Head',
  Torse: 'Chest',
  Gauche: 'Off-hand',
  Mains: 'Hands',
  Pieds: 'Feet',
  'Inventaire et profil': 'Inventory and profile',
  Inventaire: 'Inventory',
  Équipement: 'Equipment',
  Apparence: 'Appearance',
  Personnage: 'Character',
  Sac: 'Bag',
  'Garde-robe': 'Wardrobe',
  'Lier dans le chat': 'Link in Chat',
  // ui/bag-sort-button.ts
  Ranger: 'Sort',
  'Ranger le sac : équipement, consommables, puis matériaux':
    'Sort the Bag: equipment, consumables, then materials',
  'Tes cosmétiques et tes compagnons se rangent ici, sans limite de place.':
    'Your cosmetics and companions are kept here, with no limit on space.',
  '{label} : touche un objet du sac.': '{label}: tap an item in the Bag.',
  '{label} : clique un objet du sac (Maj : toute la pile).':
    '{label}: click an item in the Bag (Shift: whole stack).',
  Or: 'Gold',
  Caractéristiques: 'Stats',
  'Vie maximale ; en vert, ce que donne l’équipement':
    'Max Health; in green, what your Equipment gives',
  'Dégâts par seconde en moyenne, critiques compris ; en vert, la part de l’équipement':
    'Average damage per second, crits included; in green, your Equipment’s share',
  'En vert, les dégâts retirés aux coups d’un monstre de niveau {level}':
    'In green, the damage removed from the blows of a Level {level} monster',
  Amélioration: 'Upgrade',
  'Moyenne des {count} emplacements d’équipement : le halo s’allume à +{shine}':
    'Average of the {count} Equipment slots: the halo lights up at +{shine}',
  '{label} 1': '{label} 1',
  'Tout (×{count})': 'All (×{count})',
  Équiper: 'Equip',
  Utiliser: 'Use',
  Déplacer: 'Move',
  'Touche la case où poser l’objet.': 'Tap the slot to put the item in.',
  'Clique encore pour {verb}': 'Click again to {verb}',
  Détruire: 'Destroy',
  'Détruire un objet du sac : clique-le ensuite, ou glisse-le ici':
    'Destroy an item from the Bag: click it next, or drag it here',
  'Touche l’objet à détruire.': 'Tap the item to destroy.',
  'Clique l’objet à détruire (Échap : annuler).': 'Click the item to destroy (Esc: cancel).',
  // ui/destroy-item-modal.ts
  'Détruire {name}': 'Destroy {name}',
  'Détruire {name} ?': 'Destroy {name}?',
  'Un objet détruit disparaît pour toujours : personne ne pourra te le rendre.':
    'A destroyed item is gone for good: nobody can give it back.',
  'Toute la pile': 'The whole stack',
  '{count} / {stack}': '{count} / {stack}',
  'Détruire ×{count}': 'Destroy ×{count}',
  // ui/bench.ts, ui/craft-pieces.ts (the craftsmen's windows)
  Max: 'Max',
  'Le plus possible': 'As many as possible',
  'Il manque {gold}': '{gold} short',
  'Il en manque {count}': '{count} short',
  'Tu as / il faut': 'You have / it takes',
  'Il te manque {gold}.': 'You are {gold} short.',
  'Il te manque {count} × {name}.': 'You are missing {count} × {name}.',
  Portées: 'Worn',
  'Dans ton sac': 'In your Bag',
  Coût: 'Cost',
  // ui/smith-panel.ts, ui/smith-detail.ts
  'Choisis une pièce, portée ou dans ton sac.': 'Pick a piece, worn or in your Bag.',
  Portée: 'Worn',
  Liée: 'Bound',
  'Améliorer en +{level} · {gold}': 'Upgrade to +{level} · {gold}',
  'Chance de réussite': 'Chance of success',
  '{chance} %': '{chance}%',
  'Échec : les matériaux sont perdus, la pièce ne bouge pas.':
    'On a failure the materials are lost; the piece stays as it is.',
  // ui/alchemy-panel.ts
  '{potion} × {count} pour {gold}.': '{potion} × {count} for {gold}.',
  'Tu peux en préparer {count}': 'You can brew {count}',
  'Il te manque de quoi en préparer une.': 'You lack what it takes to brew one.',
  'Préparer ×{count} · {gold}': 'Brew ×{count} · {gold}',
  // ui/fusion-panel.ts, ui/fusion-detail.ts
  'Fusion réussie : {name} ({rarity}) pour {gold}.': 'Fusion done: {name} ({rarity}) for {gold}.',
  'Fusionner · {gold}': 'Fuse · {gold}',
  // ui/runesmith-panel.ts
  'Pour chaque rune : la garder, changer sa valeur, en tirer une autre ou la sceller.':
    'For each rune: keep it, reroll its value, draw another or seal it.',
  'Graver · {gold}': 'Engrave · {gold}',
  'Graver et sceller · {gold}': 'Engrave and seal · {gold}',
};
